module.exports = __webpack_public_path__ + "media/images/icon__xco--rb-gray@2x-37d959c83dda9648b1e832cf88ffd176.png";